import React from 'react';
import translateLabel from './components/shared/translation';
import Images from './config/Images'
import { useHistory } from 'react-router-dom'
import { logErrorAPI } from './services/api/helper';
import { connect } from 'react-redux';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: '' };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        logErrorAPI(error,true);
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, errorInfo);
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo
        })
    }

    render() {
        // const { isError } = this.props

        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <ErrorBoundaryHandler />;
        }

        return this.props.children;
    }
}

const mapStateToProps = (state) => ({
    isError : state.somethingWentWrong.isError
});


export default connect(mapStateToProps)(ErrorBoundary);

const ErrorBoundaryHandler = () => {

    let history = useHistory();

    return <div style={{ width: '100%', height: '100vh', backgroundColor: '#eceef0' }}>
        <div className="container justify-content-center">
            <div className="d-flex justify-content-center">
                <div className="d-flex sessionContainer align-items-center justify-content-center">
                    <div className="property-card text-center">
                        <img src={Images.NoApplication} alt="something went wrong" />
                        <h1>Oops...</h1>
                        <div className="col-md-9 text-center align-self-center">
                            <h5>{translateLabel('SOMETHING_WENT_WRONG')}</h5>
                            <button className="btn btn-primary" onClick={() => {
                                history.push('/home')
                            }}>{translateLabel('HOME')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

